import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Hero from "./Hero.jsx";
import {
  FaTasks,
  FaDraftingCompass,
  FaCogs,
  FaClipboardCheck,
  FaFileAlt,
  FaProjectDiagram,
  FaBuilding,
  FaBalanceScale,
  FaMapMarkedAlt,
  FaBolt,
  FaMap,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Services.css";

const services = [
  {
    title: "Project Management",
    slug: "project-management",
    icon: <FaTasks size={48} />,
    desc: "Comprehensive oversight and coordination of your construction projects from start to finish.",
  },
  {
    title: "Design & Architecture",
    slug: "design-and-architecture",
    icon: <FaDraftingCompass size={48} />,
    desc: "Expert planning and architectural design tailored to your needs.",
  },
  {
    title: "Structural Engineering",
    slug: "structural-engineering",
    icon: <FaCogs size={48} />,
    desc: "Robust and innovative structural design solutions for safe buildings.",
  },
  {
    title: "Technical Due Diligence",
    slug: "technical-due-diligence",
    icon: <FaClipboardCheck size={48} />,
    desc: "Thorough technical assessments to ensure project feasibility and compliance.",
  },
  {
    title: "Approval Due Diligence",
    slug: "approval-due-diligence",
    icon: <FaFileAlt size={48} />,
    desc: "Comprehensive approval due diligence services to ensure your project is fully compliant.",
  },
  {
    title: "Building & Layout Planning and Permissions",
    slug: "building-layout-planning-permissions",
    icon: <FaProjectDiagram size={48} />,
    desc: "Expert services in site layout design, building planning, and regulatory permissions.",
  },
  {
    title: "Land & Building Valuation Services",
    slug: "land-building-valuation",
    icon: <FaBuilding size={48} />,
    desc: "Certified valuation services to help developers, institutions, and investors understand the true worth of land and built assets.",
  },
  {
    title: "Cost Analysis & Estimation",
    slug: "cost-analysis-estimation",
    icon: <FaBalanceScale size={48} />,
    desc: "Expert-level financial assessments and estimations to help you plan better and make informed investment decisions.",
  },
  {
    title: "Interior Designing & Elevation Landscaping",
    slug: "interior-designing-elevation-landscaping",
    icon: <FaMapMarkedAlt size={48} />,
    desc: "Functional and aesthetically refined environments — from interiors to open spaces.",
  },
  {
    title: "Energy Auditing",
    slug: "energy-auditing",
    icon: <FaBolt size={48} />,
    desc: "Comprehensive energy audit solutions to help industries, institutions, and buildings improve energy efficiency.",
  },
  {
    title: "Land Surveying Services",
    slug: "land-surveying",
    icon: <FaMap size={48} />,
    desc: "Accurate and reliable land surveying solutions for successful planning, design, and execution of infrastructure projects.",
  },
];

const Services = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Our Services | Protek Consult - Civil Engineering & Architecture Services in Hyderabad</title>
        <meta name="description" content="Explore Protek Consult's comprehensive civil engineering and architecture services including structural engineering, project management, building permissions, land surveying, interior design, and energy auditing in Hyderabad, India." />
        <meta name="keywords" content="civil engineering services Hyderabad, structural engineering, project management consultancy, building permission services, layout permission, land surveying, interior designing, energy auditing, cost estimation, technical due diligence, approval due diligence, Protek Consult services" />
        <link rel="canonical" href="https://protekconsult.com/services" />
        <meta property="og:title" content="Our Services | Protek Consult - Civil Engineering & Architecture Services" />
        <meta property="og:description" content="Explore Protek Consult's comprehensive civil engineering and architecture services in Hyderabad." />
        <meta property="og:url" content="https://protekconsult.com/services" />
      </Helmet>
      <Hero />
      <div className="services-section">
        <div className="services-grid">
          {services.map((service, idx) => (
            <div
              className="service-card"
              key={idx}
              data-aos="fade-up"
              data-aos-delay={300 + idx * 100}
              data-aos-duration="800"
            >
              <div
                className="service-icon"
                data-aos="zoom-in"
                data-aos-delay="400"
              >
                {service.icon}
              </div>
              <h2 className="service-title">{service.title}</h2>
              <p className="service-desc">{service.desc}</p>
              {service.highlight ? (
                <button
                  className="service-btn highlight"
                  onClick={() => navigate(`/service/${service.slug}`)}
                >
                  BUILD NOW
                </button>
              ) : (
                <button
                  className="service-btn"
                  onClick={() => navigate(`/service/${service.slug}`)}
                >
                  Learn More
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Services;
